import React, {FC, useEffect} from "react";
import {Drawer, Form} from "antd";
import Button from "mixins/ui/button/button";
import {AdminDesignManagement} from "/react4xp/parts/admin-design-management/admin-design-management.type";
import GovServiceForm from "/react4xp/parts/admin-design-management/components/gov-service-form";
import ServiceFrom from "/react4xp/parts/admin-design-management/components/service-form";
import SbFrom from "/react4xp/parts/admin-design-management/components/sb-form";

const EditBlocks: FC<AdminDesignManagement.EditBlockProps> = (props: AdminDesignManagement.EditBlockProps) => {
    const [govForm] = Form.useForm();
    const [infoForm] = Form.useForm();
    const [sbFrom] = Form.useForm();

    const getSbUpdate = (sb: any[]) => {
        const sbData = [];

        if (sb) {
            const sbFormData = sbFrom.getFieldsValue();

            if (sbFormData.block1) {
                sbData.push(sb[sbFormData.block1]);
                sbData.push(sb[sbFormData.block2]);
            }

            sb.forEach(x => {
                if (x && !sbData.find(y => y.id === x.id)) {
                    sbData.push(x);
                }
            });
        }

        return sbData;
    };

    const onSave = () => {
        const data = {};

        props.langs.forEach(x => {
            data[x] = {
                ...props.configData[x],
                ...govForm.getFieldsValue(),
                ...infoForm.getFieldsValue(),
                sb: getSbUpdate(props.configData[x].sb)
            };
        });

        props.onSave(data);
    };

    return (
        <Drawer title="Редактирование блока" placement="right" onClose={props.onClose} open={props.open} width={500}>
            {props.selectedItem === "govService" && (
                <GovServiceForm
                    {...props}
                    govServices={props.govServices}
                    form={govForm}
                />
            )}

            {props.selectedItem === "service" && (
                <ServiceFrom
                    {...props}
                    infoServices={props.infoServices}
                    form={infoForm}
                />
            )}

            {props.selectedItem === "sb" && (
                <SbFrom
                    {...props}
                    form={sbFrom}
                />
            )}

            <hr />

            <div className="d-flex gap-3">
                <Button onClick={props.onClose}>Отмена</Button>
                <Button color="gold" onClick={onSave}>Сохранить</Button>
            </div>
        </Drawer>
    );
};

export default EditBlocks;
